<div class="gallery-page mb-footer">
    <div class="banner">
        <app-banner-header [dataBanner]="dataBanner"></app-banner-header>
    </div>
    <div class="page-able mt-md-5 mt-4">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="row px-md-0 px-sm-5 px-2">
                        <div *ngFor="let image of _albums; let i=index" 
                            class="col-md-4 py-3"
                            data-aos="fade-up">
                            <div class="pointer" (click)="open(i)">
                                <app-gallery [dataGallery]="image" [versi]="1"></app-gallery>
                            </div>
                        </div>
                        <!-- <div class="col-md-4 py-3" 
                            *ngFor="let gal of dataGallery">
                            <div class="pointer"
                                (click)="showModal(gal)">
                                <app-gallery [dataGallery]="gal"
                                            [versi]="1">
                                </app-gallery>
                            </div>
                        </div> -->
                    </div>
                    <div class="row mt-5" *ngIf="btnLoad">
                        <div class="col-lg-3 col-md-4 col-9 mx-auto">
                            <button [disabled]="textLoad == 'Loading...'"
                                    class="btn more red-btn w-100" 
                                    (click)="getMore()">
                                    {{ textLoad }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- modal board -->
    <!-- <div *ngIf="isModalShown" 
        [config]="{ show: true }" 
        (onHidden)="onHidden()" 
        bsModal 
        #autoShownModal="bs-modal"
        class="modal fade modal-gallery"
        tabindex="-1" 
        role="dialog" 
        aria-labelledby="dialog-auto-name">
        <div class="modal-x text-right pt-3 pr-5" aria-label="Close" (click)="hideModal()">
            <span class="pointer" aria-hidden="true"><i class="icon ion-ios-close"></i></span>
        </div>
        <div class="modal-dialog mt-0 modal-lg">
            <div class="modal-content">
                <div class="modal-body p-0">
                    <div class="pict">
                        <img class="w-100 h-100" [src]="modalImg" [alt]="">
                    </div>
                    <div class="detail px-3 mt-4">
                        <h6 class="tit">{{ modalTitle }}</h6>
                        <div class="desc text-justify" [innerHTML]="modalDetail"></div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>


